import { schema } from "normalizr";

export const comic = new schema.Entity("comic");
export const arrayOfComics = [comic];

export const gallery = new schema.Entity("gallery");
export const arrayOfGalleries = [gallery];

export const author = new schema.Entity("author");
export const arrayOfAuthors = [author];